export default {"src":"/_next/static/media/searchmenu.181e14b1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};